__turbopack_context__.v({
  "error": "Default-module__lmsPrq__error",
  "fakeRadio": "Default-module__lmsPrq__fakeRadio",
  "radio": "Default-module__lmsPrq__radio",
  "wrapper": "Default-module__lmsPrq__wrapper",
});
